export default __webpack_public_path__ + "static/media/Egypt.4d386421.png";